module.exports = __webpack_public_path__ + "img/conny-stage2-hungry.aa33d5ee.png";